import React from 'react';
import SvgIcon, { IconProps } from './SvgIcon';

export default function ListNumberedIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M3.6 14.3h1.2c.22 0 .33 0 .43.02.38.08.68.38.75.76.02.09.02.2.02.42 0 .23 0 .34-.02.43a.96.96 0 0 1-.75.75c-.1.02-.2.02-.43.02-.22 0-.33 0-.43.02a.96.96 0 0 0-.75.76c-.02.09-.02.2-.02.42v.72c0 .23 0 .34.07.41.07.07.18.07.41.07H6M3.6 4.7h.96c.13 0 .24.11.24.25V9.5m0 0H3.6m1.2 0H6" />
      <path d="M9.08 5H19.9M9.08 12H19.9M9.08 19H19.9" />
    </SvgIcon>
  );
}
